import { styled } from '../../Utilities';
import { DetailsListBase } from './DetailsList.base';
import { getDetailsListStyles } from './DetailsList.styles';
export var DetailsList = styled(DetailsListBase, getDetailsListStyles, undefined, {
    scope: 'DetailsList',
});
//# sourceMappingURL=DetailsList.js.map